<template>
  <div class="invite-detail-card">
    <div class="card-header">
      <div class="header-wrap">
        <div class="header-content">
          <img class="icon" src="@/assets/images/invite/icon_reward.webp" />
          <div class="title">{{ $t('inviteFriend.accumulatedRewards') }}</div>
          <div class="reward">{{ buildTotalReward() }}</div>
        </div>
        <img class="bg-img" src="@/assets/images/invite/card_head_bg.webp" />
      </div>
    </div>

    <div class="card-content">
      <div class="info">
        <!-- 邀请人数 -->
        <div class="count-item">
          <div class="item-num">{{ inviteNumStr }}</div>
          <div class="item-label">{{ $t('inviteFriend.inviteNum') }}</div>
        </div>
        <div class="count-divider" />
        <!-- 已注册 -->
        <div class="count-item">
          <div class="item-num">{{ registeredStr }}</div>
          <div class="item-label">{{ $t('inviteFriend.registered') }}</div>
        </div>
        <div class="count-divider" />
        <!-- 已开户 -->
        <div class="count-item">
          <div class="item-num">{{ accountOpenedStr }}</div>
          <div class="item-label">{{ $t('inviteFriend.accountOpened') }}</div>
        </div>
        <div class="count-divider" />
        <!-- 入金达标 -->
        <div class="count-item">
          <div class="item-num">{{ depositedStr }}</div>
          <div class="item-label">{{ $t('inviteFriend.deposited') }}</div>
        </div>
        <div class="count-divider" />
        <!-- 已交易 -->
        <div class="count-item">
          <div class="item-num">{{ tradedStr }}</div>
          <div class="item-label">{{ $t('inviteFriend.traded') }}</div>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
  import { thousandBitSeparator } from '@/utils/common.js'

  export default {
    name: 'invite-detail-card',

    props: ['inviteData'],

    computed: {
      rewardAmount() {
        return this.getObjValue(this.inviteData, 'rewardAmount')
      },
      inviteCount() {
        return this.getObjValue(this.inviteData, 'inviteCount')
      },
      registeredCount() {
        return this.getObjValue(this.inviteData, 'registeredCount')
      },
      openAccountCount() {
        return this.getObjValue(this.inviteData, 'openAccountCount')
      },
      depositCount() {
        return this.getObjValue(this.inviteData, 'depositCount')
      },
      tradeCount() {
        return this.getObjValue(this.inviteData, 'tradeCount')
      },

      inviteNumStr() {
        return this.genCountStr(this.inviteCount)
      },
      registeredStr() {
        return this.genCountStr(this.registeredCount)
      },
      accountOpenedStr() {
        return this.genCountStr(this.openAccountCount)
      },
      depositedStr() {
        return this.genCountStr(this.depositCount)
      },
      tradedStr() {
        return this.genCountStr(this.tradeCount)
      }
    },

    methods: {
      getObjValue(obj, key) {
        if (!obj) {
          return null
        }
        return obj[key]
      },

      genCountStr(count) {
        if (count) {
          return count + ''
        } else {
          return count === 0 ? '0' : '-'
        }
      },

      buildTotalReward() {
        let res = 'HKD '
        if (this.rewardAmount) {
          res += thousandBitSeparator(this.rewardAmount, 2)
        } else {
          res += this.rewardAmount === 0 ? '0.00' : '- -'
        }
        return res
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invite-detail-card {
    position: relative;

    .card-header {
      position: relative;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      background: linear-gradient(180deg, #ffffff 58%, rgba(255, 255, 255, 0.2) 100%);
      padding: 0.5px;

      .header-wrap {
        height: 62px;
        background: linear-gradient(90deg, #0691ff 0%, #8cccff 100%);
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        overflow: hidden;
        position: relative;
      }

      .header-content {
        height: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 16px;
        padding-top: 7px;

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }

        .title {
          font-size: 12px;
          line-height: 16px;
          color: #ffffff;
          padding-right: 4px;
        }

        .reward {
          font-size: 18px;
          font-weight: 500;
          line-height: 22px;
          color: #ffffff;
        }
      }

      .bg-img {
        position: absolute;
        top: -18px;
        right: -27px;
        width: 100px;
        height: 100px;
      }
    }

    .card-content {
      position: relative;
      border-radius: 12px;
      background: #ffffff;
      margin-top: -12px;

      .info {
        padding: 24px 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .count-item {
        width: calc(65 / 375 * 100vw);

        .item-num {
          font-family: DIN-Bold;
          font-size: 18px;
          line-height: 20px;
          text-align: center;
          color: #333333;
        }

        .item-label {
          font-size: 11px;
          line-height: 18px;
          text-align: center;
          color: #333333;
        }
      }

      .count-divider {
        width: 1px;
        height: 16px;
        background: #eeeeee;
        transform: scaleX(0.5);
      }
    }
  }
</style>
